import { Container, Row, Col, Button } from 'react-bootstrap';
import { ArrowRight, Smartphone, Globe } from 'lucide-react';
import { useDispatch } from "react-redux";
import {setFromLandingPage} from "../../../Redux/landingPageSlice"



const CTASection = () => {
  const dispatch = useDispatch()
  const handleStartClick = () => {
    dispatch(setFromLandingPage(true))

    document?.getElementById("headerlogin").click();
  }

  return (
    <section className="section-padding bg-green ">
      <Container>
        <Row>
          <Col>
            <div className="text-center">
              <h2 className="display-5 fw-bold mb-4  text-white" style={{ letterSpacing: "-2.4px" }}>
                Ready to Start Earning?
              </h2>
              <p className="lead mb-5 mx-auto  text-white" style={{ maxWidth: "600px", lineHeight: "28px" }}>
                Join thousands of successful lenders and turn your unused
                items into income today. It's free to get started and takes less
                than 5 minutes to create your first listing.
              </p>

              <div className=" d-flex flex-column flex-sm-row gap-3 text-dark-green justify-content-center">
                <Button
                  size="lg"
                  className="cta-btn px-4 py-3 fs-5 text-dark-green"
                  style={{
                    backgroundColor: 'white',
                    border: 'none',
                    fontWeight: 500

                  }}

                  onClick={handleStartClick}
                >

                  Create Your First Listing
                  <ArrowRight size={20} className="ms-2" />

                </Button>

              </div>

              <div className="mt-4 small opacity-75 text-white">
                No setup fees • No monthly charges • Keep 85% of earnings
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CTASection;